import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFoundScreen: React.FC = () => {
  return (
    <div className="not-found">
      <div className="container not-found-card ">
        <div className="not-found-icon">🧭</div>

        <p>Página não encontrada</p>

        <div className="not-found-message">
          <p>
            Parece que você se perdeu pelo caminho. A página que você está
            procurando não existe ou foi movida.
          </p>
        </div>

        <div>
          <Link to="/" className="btn-primary big text-center">
            Voltar para o Início
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundScreen;
